import { render, staticRenderFns } from "./GoToAllIntegrationLogs.vue?vue&type=template&id=477c0a8f"
import script from "./GoToAllIntegrationLogs.vue?vue&type=script&lang=js"
export * from "./GoToAllIntegrationLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports